import ReportCollection from "@/classes/ReportCollection";
import Vue from "vue";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import HolidayList from "@/types/Holiday/HolidayList";
import TeamList from "@/types/Team/TeamList";
import User from "@/types/User/User";
export default Vue.extend({
    name: "MyTeam",
    data() {
        return {
            teams: [],
            teamList: null,
            employee: this.$store.getters.getLoggedInUser,
            currentUser: null,
            loading: false,
            preloaded: false,
            selectedDate: this.$store.getters.getSelectedDate,
            dateInfo: {
                year: 0,
                month: null,
                week: 0,
                weekHours: 0,
                monthHours: 0,
            },
        };
    },
    components: {
        IconBox,
        IconBoxContent,
        WhiteBox,
    },
    created() {
        this.$store.commit("setSelectedDate", {
            date: this.$store.getters.getSelectedDate,
        });
        this.initalLoad();
    },
    mounted() {
        this.getDateInfo();
    },
    methods: {
        async initalLoad() {
            const dateObject = {
                year: window.dateHandler.getYear(this.$store.getters.getSelectedDate),
                month: window.dateHandler.getMonthNumber(this.$store.getters.getSelectedDate),
            };
            try {
                const values = await Promise.all([
                    this.$store.dispatch("loadHolidaysAsync", { year: dateObject.year }),
                    this.$store.dispatch("adminLoadTeamsAsync"),
                    this.$store.dispatch("getCurrentUser"),
                ]);
                //set the holiday collection
                this.$store.commit("setHolidays", {
                    data: values[0].data,
                    year: dateObject.year,
                });
                this.$data.holidays = new HolidayList(values[0].data);
                const tempTeams = new TeamList(values[1].data);
                //Get the current user
                this.$data.currentUser = new User(values[2].data);
                //filter the teams based on the logged in user
                tempTeams.teams = tempTeams.teams.filter((team) => {
                    return team.teamManagerId === this.$data.currentUser.id;
                });
                this.$data.teamList = tempTeams; //set the team in the state to the filtered team list for the user.
            }
            catch (err) {
                window.errorHandler.logError(err, "MyTeam.vue -> initalLoad");
            }
            finally {
                this.$data.preloaded = true;
            }
        },
        //   loadTeamReports2(){
        //   //get the dates for this month
        //   const fromDate = (window as any).dateHandler.getStartOfMonth(this.$store.getters.getSelectedDate).format("YYYY-MM-DDT00:00:00Z");
        //   const toDate = (window as any).dateHandler.getEndOfMonth(this.$store.getters.getSelectedDate).format("YYYY-MM-DDT23:59:00Z");
        //   //load the reprots for all teams the team Manager has
        //       this.$data.employee.teamManagerIds.forEach((teamId: string) => {
        //         this.$data.loading = true;
        //           this.$store.dispatch('getTeamManagerReportsAsync',{teamId: teamId, from: fromDate, to:toDate}).then((results: any) => {
        //             console.log("teammmm", this.$data.teams)
        //             this.$data.teams.addReportsToTeam(teamId, results.data);
        //             this.$data.loading = false;
        //         }).catch((err: any) => {
        //           (window as any).errorHandler.logError(err, 'MyTeam.vue -> loadTeamReports -> getTeamManagerReportsAsync');
        //           this.$data.loading = false;
        //         });
        //       });
        // },
        getDateInfo() {
            this.$data.dateInfo = this.$store.getters.getDateInfo;
        },
        selectPreviousMonth() {
            const newDate = window.dateHandler
                .subtractMonths(this.$store.getters.getSelectedDate, 1)
                .startOf("month")
                .format("YYYY-MM-DD");
            this.$store.commit("setSelectedDate", { date: newDate });
            this.loadAdminTimeReports();
            this.getDateInfo();
            this.$data.loading = true;
        },
        selectNextMonth() {
            const newDate = window.dateHandler
                .addMonths(this.$store.getters.getSelectedDate, 1)
                .startOf("month")
                .format("YYYY-MM-DD");
            this.$store.commit("setSelectedDate", { date: newDate });
            this.loadAdminTimeReports();
            this.getDateInfo();
            this.$data.loading = true;
        },
        loadAdminTimeReports() {
            this.$data.loading = true;
            try {
                const result = this.$store.dispatch("loadAdminTimeReportsAsync", {
                    date: this.$store.getters.getSelectedDate,
                });
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(result.data);
                this.$data.reports = tempReports.getReportsForEmployeeMonth(this.$route.params.user);
                this.$data.loading = false;
            }
            catch (err) {
                window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
                this.$data.loading = false;
            }
        },
    },
});
